import { Controller } from '@hotwired/stimulus'

export default class OptionController extends Controller {
  static targets = [
    'amount',
    'add',
    'remove'
  ]

  static values = {
    modifierId: String,
    id: String,
    price: Number,
    amount: { type: Number, default: 0 },
    isReachedLimit: { type: Boolean, default: false }
  }

  add (event) {
    if (this.canAddOption) {
      this.amountValue += 1
      this.dispatch('addOption', { detail: this.option, bubbles: true })
    }
  }

  remove (event) {
    if (this.canRemoveOption) {
      this.amountValue -= 1
      this.dispatch('removeOption', { detail: this.option, bubbles: true })
    }
  }

  modifierChanged ({ detail: { isReachedLimit } }) {
    this.isReachedLimitValue = isReachedLimit
  }

  amountValueChanged () {
    this.removeTarget.disabled = !this.canRemoveOption
    this.amountTarget.textContent = this.amountValue.toString()

    if (this.canRemoveOption) {
      this.amountTarget.classList.replace('hidden', 'block')
    } else {
      this.amountTarget.classList.replace('block', 'hidden')
    }
  }

  isReachedLimitValueChanged () {
    this.addTarget.disabled = !this.canAddOption
  }

  get canAddOption () {
    return !this.isReachedLimitValue
  }

  get canRemoveOption () {
    return this.amountValue > 0
  }

  get option () {
    return {
      id: this.idValue,
      price: this.priceValue,
      amount: this.amountValue
    }
  }
}
